import { render, staticRenderFns } from "./Finalizar.vue?vue&type=template&id=406329b7&"
import script from "./Finalizar.vue?vue&type=script&lang=js&"
export * from "./Finalizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports